module.exports = __webpack_public_path__ + "img/guyuan.26fa3bb9.png";